import keyMirror from 'keymirror';

export default keyMirror({
  LOAD_CATEGORIES: null,
  CATEGORIES_WERE_LOADED: null,
  ERROR_LOADING_CATEGORIES_DATA: null,
  SELECT_CATEGORY: null
});
